import { PageContainer, PageHeader, Spread } from '@/components/Atoms'
import { Card, CardContent } from '@/components/Card'
import { IntroductionDialog } from '@/components/IntroductionDialog'
import { useDefaultTerritories, useQueryDefaults } from '@/hooks/queries/defaults/useQueryDefaults'
import { storeSearchSchema } from '@/hooks/queries/useStores'
import { INTRO_DIALOGS } from '@/stores/tutorials'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import StoreDataTable from './-components/StoreDataTable'

export const Route = createFileRoute('/_auth/_modules/_app/customers/stores/')({
  component: StoresPage,
  validateSearch: (search) => storeSearchSchema.parse(search),
})

function StoresPage() {
  const { t } = useTranslation('stores')
  const navigate = Route.useNavigate()
  const search = Route.useSearch()

  const defaultTerritories = useDefaultTerritories()

  useQueryDefaults({
    search,
    navigate,
    defaults: { territory: defaultTerritories },
  })

  return (
    <PageContainer>
      <IntroductionDialog
        dialogId={INTRO_DIALOGS.STORES}
        title={t('tutorials.stores.dialog.title')}
        guideUrl="/customers/stores"
      >
        {t('tutorials.stores.dialog.description')}
      </IntroductionDialog>

      <Spread>
        <PageHeader>{t('storesPage.header')}</PageHeader>
      </Spread>

      <Card>
        <CardContent className="pt-6">
          <StoreDataTable />
        </CardContent>
      </Card>
    </PageContainer>
  )
}
